'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var objAsArr = function objAsArr(obj) {
  if (Array.isArray(obj) || (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
    console.error('invalid object', obj);
    throw new Error('Invalid object provided');
  }

  return (0, _keys2.default)(obj).map(function (id) {
    return (0, _extends3.default)({}, obj[id], {
      id: id
    });
  });
};

exports.default = objAsArr;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/objAsArray.js
// module id = 69
// module chunks = 0